import type { IInteractableVisual, InteractableVisualOptions } from '../IRenderer';

/**
 * createInteractableVisual — substrate-agnostic factory for loot-drop visuals.
 *
 * Phase H10 Arc λ.10 (2026-05-10): PhaserInteractableVisual fallback removed.
 * PixiFactoriesRegistry wires the Pixi impl at boot.
 */

type PixiFactory = (opts: InteractableVisualOptions) => IInteractableVisual;

let pixiFactory: PixiFactory | null = null;

export function registerPixiInteractableFactory(fn: PixiFactory): void {
  pixiFactory = fn;
}

export function createInteractableVisual(
  _scene: unknown,
  opts: InteractableVisualOptions,
): IInteractableVisual {
  if (!pixiFactory) {
    throw new Error('[createInteractableVisual] Pixi factory not registered. Call registerAllPixiFactories() at boot.');
  }
  return pixiFactory(opts);
}
